/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MentionSuggestionsResponse } from './MentionSuggestionsResponse';
import {
    MentionSuggestionsResponseFromJSON,
    MentionSuggestionsResponseFromJSONTyped,
    MentionSuggestionsResponseToJSON,
    MentionSuggestionsResponseToJSONTyped,
} from './MentionSuggestionsResponse';

/**
 * 
 * @export
 * @interface GetMentionSuggestions200Response
 */
export interface GetMentionSuggestions200Response {
    /**
     * 
     */
    data?: MentionSuggestionsResponse;
}

/**
 * Check if a given object implements the GetMentionSuggestions200Response interface.
 */
export function instanceOfGetMentionSuggestions200Response(value: object): value is GetMentionSuggestions200Response {
    return true;
}

export function GetMentionSuggestions200ResponseFromJSON(json: any): GetMentionSuggestions200Response {
    return GetMentionSuggestions200ResponseFromJSONTyped(json, false);
}

export function GetMentionSuggestions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMentionSuggestions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : MentionSuggestionsResponseFromJSON(json['data']),
    };
}

export function GetMentionSuggestions200ResponseToJSON(json: any): GetMentionSuggestions200Response {
    return GetMentionSuggestions200ResponseToJSONTyped(json, false);
}

export function GetMentionSuggestions200ResponseToJSONTyped(value?: GetMentionSuggestions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': MentionSuggestionsResponseToJSON(value['data']),
    };
}

